import type {DraftOrExistingIssue} from '../../content-preview-types'
import type {TreeNode} from '../use-draft-issue-tree-map'
import {BlockedByList} from './BlockedByList'
import {BlockingList} from './BlockingList'
import {SubissuesList} from './SubissuesList'

export function RelationshipsSection({issueNode}: {issueNode: TreeNode<DraftOrExistingIssue>}) {
  return (
    <>
      <SubissuesList issueNode={issueNode} />
      <BlockedByList issueNode={issueNode} />
      <BlockingList issueNode={issueNode} />
    </>
  )
}
